export const partnersData = [
    {
        id: 1,
        name: "Instituto Federal da Bahia",
        category: "Instituição de Ensino Superior e Técnico",
        description: "Instituto Federal de Educação, Ciência e Tecnologia da Bahia (IFBA) é uma instituição pública federal de ensino superior e técnico, vinculada ao Ministério da Educação do Brasil.",
        image: "./partners-images/ifba.png"
    },
    {
        id: 2,
        name: "Nubank",
        category: "Instituição Financeira",
        description: "Uma das maiores plataformas de serviços financeiros digitais do mundo, atendendo a mais de 122 milhões de clientes no Brasil, México e Colômbia. A empresa tem liderado uma transformação na indústria, usando dados e tecnologia proprietária para desenvolver produtos e serviços inovadores.",
        image: "./partners-images/nubank.png"
    }
]